import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import useRefreshToken from "./useRefreshToken";

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    const verify = async () => {
      try {
        await refresh();
      } finally {
        setIsLoading(false);
      }
    };

    !auth?.accessToken ? verify() : setIsLoading(false);
  }, []);

  return isLoading ? <p>Loading...</p> : <Outlet />;
};

export default PersistLogin;
